import { render } from "./Pagenation.vue?vue&type=template&id=3debb4a2&scoped=true&ts=true"
import script from "./Pagenation.vue?vue&type=script&lang=ts"
export * from "./Pagenation.vue?vue&type=script&lang=ts"

import "./Pagenation.vue?vue&type=style&index=0&id=3debb4a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3debb4a2"]])

export default __exports__